var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9854 12.341C9.16041 12.341 6.81241 9.995 6.81241 7.219C6.81241 4.347 9.16041 2 11.9864 2C14.9084 2 17.1594 4.346 17.1594 7.219C17.1544 8.58205 16.6084 9.88733 15.6413 10.848C14.6743 11.8086 13.3655 12.346 12.0024 12.342L11.9854 12.341ZM11.9854 5.017C10.7894 5.017 9.87941 6.022 9.87941 7.22C9.87941 8.416 10.7894 9.326 11.9864 9.326C13.2314 9.326 14.0934 8.416 14.0934 7.22C14.0944 6.021 13.2314 5.017 11.9854 5.017ZM14.0454 16.603L16.9684 19.428C17.5434 20.049 17.5434 20.959 16.9684 21.534C16.3464 22.155 15.3874 22.155 14.9084 21.534L11.9864 18.661L9.16041 21.534C8.87341 21.821 8.48941 21.964 8.05741 21.964C7.72241 21.964 7.33941 21.82 7.00341 21.534C6.42841 20.959 6.42841 20.049 7.00341 19.427L9.97341 16.602C8.90085 16.2844 7.87195 15.8346 6.91041 15.263C6.19141 14.88 6.04841 13.923 6.43141 13.204C6.91041 12.486 7.77241 12.295 8.53941 12.774C9.57801 13.4078 10.7712 13.7431 11.9879 13.7431C13.2046 13.7431 14.3978 13.4078 15.4364 12.774C16.2034 12.295 17.1124 12.486 17.5434 13.204C17.9754 13.923 17.7824 14.879 17.1114 15.263C16.2024 15.838 15.1484 16.269 14.0464 16.604L14.0454 16.603Z",
    fill: "#C4CBD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkSocial);
export default __webpack_public_path__ + "static/media/okSocial.69e00796cd9139a00cfd582974513502.svg";
export { ForwardRef as ReactComponent };